import { styled } from '@linaria/react';

import { Text } from '~components/Typography';

export const BotModelInfoContainer = styled.div`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	gap: 10px;
	opacity: 0.6;

	${Text} {
		span {
			text-decoration: underline;
			text-decoration-style: dotted;
		}
	}
`;
